import { FilterFacets, ParameterValue, SearchStudyCardInfo } from '@/study-search/domain';
import { SortingType } from '@/study-search/enums';

import StudySearchClient from '../infrastructure/StudySearchClient';
import Logger from '@/search-page/platform/Logger';
import { PortalType } from '@studyportals/domain-client';
import { FacetOptionValue } from '@studyportals/search-filters/server-side';

class SearchResultsPresenter {
	public async retrieveSearchResults(
		parameters: ParameterValue[],
		portalType: PortalType,
		pageSize?: number,
		start?: number,
		sorting?: SortingType,
		facetsToRequest?: FacetOptionValue[]
	): Promise<{ results: SearchStudyCardInfo[], facets: FilterFacets[] | undefined, count: number; }> {
		try {
			return await StudySearchClient.retrieveSearchResults(parameters, portalType, pageSize, start, sorting, facetsToRequest);
		} catch (error) {
			if (error instanceof Error) {
				const info = {
					name: error.name,
					message: error.message,
					parameters,
				};
				if (error.stack) {
					info['stack'] = error.stack;
				}

				Logger.logError(`Search results could not be retrieved`, info);
			}

			return {
				results: [],
				facets: undefined,
				count: 0
			};
		}
	}
}

export default new SearchResultsPresenter();
